import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SurveyForm } from '../../../../components/common/survey/form/SurveyForm';
import { SurveyInputHeader } from '../../../../components/common/survey/inputs/SurveyInputHeader';
import { SurveyOverviewNavigationItem } from '../../../../components/common/survey/inputs/SurveyOverviewNavigationItem';
import { SurveyOverviewNavigationList } from '../../../../components/common/survey/inputs/SurveyOverviewNavigationList';
import { sellTractorSurveySteps } from '../../../../constants/survey/sellTractorSurvey';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { useGetUserProfile } from '../../../../hooks/user/useGetUserProfile';
import { userSellTractorSurveySlice } from '../../../../store/userSellTractorSurveySlice';
import { SellTractorSurveyPageWrapper } from '../SellTractorSurveyPageWrapper';

export const SellTractorSurveyRequiredInputOverviewPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { userProfile } = useGetUserProfile();
  const userSellTractorSurveySelector = useAppSelector((state) => state.userSellTractorSurvey);
  const userSellTractorSurveyActions = userSellTractorSurveySlice.actions;
  const defaultInputTexts = {
    select: '선택하기',
    enter: '입력하기',
  };
  const navigateToRequiredInputs = () => {
    navigate('/survey/progress/sell-tractor/required-inputs', { replace: true });
  };

  const navigateToLocationInput = () => {
    navigate('/survey/progress/sell-tractor/location', { replace: true });
  };

  const currentStep = sellTractorSurveySteps.STEP1;
  const steps = Object.keys(sellTractorSurveySteps);

  const overviewList = [
    {
      label: '브랜드',
      inputValue: userSellTractorSurveySelector.brand || defaultInputTexts.select,
      isDisabledOnEdit: true,
      onClickHandler: navigateToRequiredInputs,
    },
    {
      label: '모델',
      inputValue: userSellTractorSurveySelector.model || defaultInputTexts.select,
      isDisabledOnEdit: true,
      onClickHandler: navigateToRequiredInputs,
    },
    {
      label: '마력',
      inputValue: userSellTractorSurveySelector.engineOutputInPs || defaultInputTexts.enter,
      isDisabledOnEdit: true,
      onClickHandler: navigateToRequiredInputs,
    },
    {
      label: '연식',
      inputValue: userSellTractorSurveySelector.manufacturedYear || defaultInputTexts.enter,
      isDisabledOnEdit: false,
      onClickHandler: navigateToRequiredInputs,
    },
    {
      label: '사용 시간',
      inputValue: userSellTractorSurveySelector.operationTime || defaultInputTexts.enter,
      isDisabledOnEdit: false,
      onClickHandler: navigateToRequiredInputs,
    },
    {
      label: '판매 지역',
      inputValue: userSellTractorSurveySelector.location || defaultInputTexts.enter,
      isDisabledOnEdit: false,
      onClickHandler: navigateToLocationInput,
    },
  ];

  const isNextStepAllowed =
    !!userSellTractorSurveySelector.brand &&
    !!userSellTractorSurveySelector.model &&
    !!userSellTractorSurveySelector.engineOutputInPs &&
    !!userSellTractorSurveySelector.manufacturedYear &&
    !!userSellTractorSurveySelector.operationTime &&
    !!userSellTractorSurveySelector.location;

  useEffect(() => {
    dispatch(userSellTractorSurveyActions.changeIsSellTractorSurveyStartedProperly(true));
  }, [dispatch, userSellTractorSurveyActions]);

  useEffect(() => {
    const { regionDepth1, regionDepth2, regionDepth3 } = userProfile || {};

    if (!userSellTractorSurveySelector.location && regionDepth1 && regionDepth2 && regionDepth3) {
      const location = `${regionDepth1} ${regionDepth2} ${regionDepth3}`;
      dispatch(userSellTractorSurveyActions.changeLocation(location));
    }
  }, [userProfile, userSellTractorSurveySelector.location]);

  return (
    <>
      <SellTractorSurveyPageWrapper
        headerTitle={'판매하실 매물의\n필수 정보를 입력해주세요'}
        canConfirm={isNextStepAllowed}
        steps={steps}
        currentStep={currentStep}
        confirmHandler={() => {
          navigate('/survey/progress/sell-tractor/option', { replace: true });
        }}
      >
        <SurveyForm padding={'0px 16px'}>
          <SurveyInputHeader inputTitle={'매물 필수 정보'} isRequired />
          <SurveyOverviewNavigationList>
            {overviewList.map((item) => {
              const { sellTractorIdForEdit } = userSellTractorSurveySelector;
              const isInputValueDefault = Object.values(defaultInputTexts).includes(String(item.inputValue));

              const isActiveNewTractor = !sellTractorIdForEdit && !isInputValueDefault;
              const isActiveEditTractor = !!sellTractorIdForEdit && !isInputValueDefault && !item.isDisabledOnEdit;

              const isActive = isActiveNewTractor || isActiveEditTractor;

              return <SurveyOverviewNavigationItem key={item.label} isActive={isActive} {...item} />;
            })}
          </SurveyOverviewNavigationList>
        </SurveyForm>
      </SellTractorSurveyPageWrapper>
    </>
  );
};
